// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609171016/js/" + chunkId + "." + {"44":"e13f91aa","225":"4f0f1230","481":"38fa239d","486":"929acca2","770":"39f23ea6"}[chunkId] + ".0.6118407456356819.chunk.js";
};